


















































































import { PolicyInsurerForDashboard } from '@/api';
import Vue from '@/vue';
import { BModal } from 'bootstrap-vue';
import { PropType } from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    insurer: {
      type: Object as PropType<PolicyInsurerForDashboard>,
      required: false,
      default: 'N/A',
    },
  },
})
export default class BiFinancialStrengthRating extends Vue {
  show(): void {
    (this.$refs.modal as BModal).show();
  }
  hide(): void {
    (this.$refs.modal as BModal).hide();
  }
}
